/**
 * An organization's name as the product shows it.
 *
 * Staff keep an alias or a note in parentheses in an organization's stored
 * name ("Example State University (ESU)", "Example Advisors (acquired Another
 * Firm)"). That is for us; the people in the organization see the name
 * alone. Internal admin pages read the stored name as is.
 */

// One parenthetical with nothing nested in it, and the space before it.
// Applied until nothing matches, so nested groups go from the inside out.
const INNERMOST_PARENTHETICAL = /\s*\([^()]*\)/g;

/** The stored name without its parenthetical groups; the stored name itself
 *  when nothing else is left. The backend applies the same rule to the names
 *  it writes into labels and emails (`fp/organization_display.py`). */
export function displayOrganizationName(name: string): string {
  let shown = name;
  for (;;) {
    const stripped = shown.replace(INNERMOST_PARENTHETICAL, "");
    if (stripped === shown) break;
    shown = stripped;
  }
  return shown.trim() || name;
}
